import React from 'react'
import PropTypes from 'prop-types'

import { combineClasses } from '~/util'

import styles from './Lockbox.module.scss'
import { Modal } from '../modal'
import { Image } from '../image'
import { DoorCode, ItemName, LockAction } from '..'

/**
 * `<Lockbox>`
 *
 * @param {object} props
 * @param {string} [props.className]
 * @param {string | null} [props.lockInstructionImageUrl]
 * @param {string | null} [props.lockInstructionText]
 */
export function Lockbox({
  className,
  lockInstructionImageUrl,
  lockInstructionText,
  ...rest
}) {
  const [isModalVisable, setIsModalVisable] = React.useState(false)
  return (
    <div
      data-testid="Lockbox"
      className={combineClasses(styles.Lockbox, className)}
      {...rest}
    >
      {(lockInstructionText || lockInstructionImageUrl) && (
        <section className={styles.lockBoxCodeSection}>
          {lockInstructionText && (
            <ItemName className={styles.lockBoxCodeWrapper}>
              Lock Box Code:
              <DoorCode
                className={styles.lockBoxCode}
                label={null}
                access={'#' + lockInstructionText}
                accessType={'PIN'}
                startTime={null}
                endTime={null}
                onLockError={() => {}}
              />
            </ItemName>
          )}
          <br />
          {lockInstructionImageUrl && (
            <LockAction
              button
              data-testid="lockBoxPDFButton"
              className={styles.lockBoxPDFButton}
              onClick={() => setIsModalVisable(true)}
            >
              Access Instructions
            </LockAction>
          )}
          <Modal
            data-testid="lockInstructionImageUrlModal"
            className={styles.modal}
            isOpen={isModalVisable}
            setIsOpen={setIsModalVisable}
            label="community lock box instructions"
            closeOnBackgroundClick
          >
            <Image
              data-testid="lockInstructionImageUrl"
              fit={null}
              src={lockInstructionImageUrl}
            />
          </Modal>
        </section>
      )}
    </div>
  )
}

Lockbox.propTypes = {
  lockInstructionText: PropTypes.string,
  lockInstructionImageUrl: PropTypes.string,
}
